import { AdminGlassDisclosure } from '../AdminGlassDisclosure';
import { BookOpen } from 'lucide-react';

const PATTERNS: { id: string; title: string; who: string; steps: string[] }[] = [
  {
    id: 'A',
    title: 'Звонок с телефона (нет Telegram)',
    who: 'Менеджер / админ',
    steps: [
      'Воронка → «+» или «Новый лид»: имя, телефон, предварительный комментарий.',
      'Лид сразу на вас (кто создал). В карточке → «Запись на замер» или задача follow-up.',
      'После согласования: «Оформить заказ» — в Kanban появится ONV-… на вашем менеджере.',
    ],
  },
  {
    id: 'B',
    title: 'Клиент написал в Telegram',
    who: 'Менеджер',
    steps: [
      '«Входящие» → «Взять» — лид закреплён, открывается карточка.',
      'Блок «Переписка» — история чата; «Запись» — итог звонка по датам (как борда).',
      'Задача с дедлайном → смена этапа → при оплате «Оформить заказ» / заказ из корзины.',
    ],
  },
  {
    id: 'C',
    title: 'Заявка на замер с сайта / бота',
    who: 'Менеджер + замерщик',
    steps: [
      'Система создаёт сделку ONV и привязывает замер — не дублируйте «Заявку на замер» вручную.',
      'Воронка: одна карточка ONV; замер и отчёт — внутри сделки (этап «Замер»).',
      'Замерщик: раздел «Замеры»; менеджер: «Открыть сделку» у клиента.',
    ],
  },
  {
    id: 'D',
    title: 'КП через конфигуратор → заказ',
    who: 'Менеджер + клиент (партнёр/дизайнер)',
    steps: [
      'Клиент (или партнёр со скидкой) собирает корзину в каталоге → оформляет заказ.',
      'Заказ в Kanban; менеджер «Забрать» или назначен при конверсии лида.',
      'Менеджер ведёт этапы, ленту комментариев, задачи; цех видит «Производство».',
    ],
  },
  {
    id: 'E',
    title: 'Партнёр / дизайнер',
    who: 'Покупатель с меткой роли',
    steps: [
      'В «Клиенты» — роль partner/designer, скидка и crm_tags.',
      'Их заказы в воронке как обычные; скидка в чеке автоматически.',
      'Комментарии и этапы — те же блоки в карточке заказа.',
    ],
  },
  {
    id: 'F',
    title: 'Производство',
    who: 'Роль production',
    steps: [
      'Без вкладки «Воронка» — заказы и лента.',
      'В заказе: записи visibility «цех», сводка production_notes.',
      'Handoff после оплаты — кнопка в карточке сделки (менеджер).',
    ],
  },
];

export function CrmWorkflowGuide() {
  return (
    <AdminGlassDisclosure
      accent="violet"
      defaultOpen={false}
      title="Сценарии работы"
      subtitle="Как клиент приходит и кто что делает"
      icon={<BookOpen size={16} color="#B794F4" />}
    >
      <div className="space-y-3">
        {PATTERNS.map((p) => (
          <div
            key={p.id}
            className="rounded-xl p-3"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}
          >
            <div className="flex items-start gap-2 mb-1.5">
              <span
                className="shrink-0 w-6 h-6 rounded-lg flex items-center justify-center text-[10px] font-black"
                style={{ background: 'rgba(159,122,234,0.2)', color: '#D6BCFA' }}
              >
                {p.id}
              </span>
              <div className="min-w-0">
                <p className="text-xs font-bold" style={{ color: 'var(--text-1)' }}>
                  {p.title}
                </p>
                <p className="text-[10px] mt-0.5" style={{ color: 'var(--text-3)' }}>
                  {p.who}
                </p>
              </div>
            </div>
            <ol className="text-[11px] space-y-1 list-decimal pl-5 leading-relaxed" style={{ color: 'var(--text-2)' }}>
              {p.steps.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </AdminGlassDisclosure>
  );
}
